// @flow
// @todo remove all but `getQuestionSetsByGuideLevelIdQuery` function
import {set} from 'lodash';
import sessionStore from 'client/Session/SessionStore';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {applySort} from 'components/PracticeView/PracticeViewToolbar/Sort/sort.utils';
import masqueradeStore from 'generic/Masquerade/Masquerade.store';

type QuestionSetFunctionArguments = {
  difficultyFilters: Array<number>,
  onlyIncludeAnsweredQuestions: boolean,
  onlyIncludeUnansweredQuestions: boolean,
  guideLevelSlug: string,
  guideLevelIds: string,
  page: number,
  pageSize: number,
  randomSeed: number,
  sortBy: string,
  studentId: string,
  teacherId: string,
  subjectSlug: string | Array<string>,
  tags: string,
  questionSetSlug: string
};

export function getQuestionSetsByGuideLevelIdQuery(
  guideLevelId,
  numQuestions = 'infinite',
  questionSetIds = []
) {
  const metaContext = {
    meta: {
      context: {
        guide_level: {
          id: guideLevelId
        }
      }
    }
  };

  const userId = masqueradeStore.getUserIdByMasqueradeState();
  if (sessionStore.hasTeacherAccess()) {
    set(metaContext, 'meta.context.user.role', 'teacher');
  }

  if (userId) {
    set(metaContext, 'meta.context.user.id', userId);
  } else {
    set(metaContext, 'meta.context.no_user', true);
  }

  let query = resource('question_sets_v1')
    .mandarkEndpoint(['guide_levels_v2', guideLevelId, 'question_sets_v1'])
    .filter(
      {
        id: questionSetIds.join(',')
      },
      questionSetIds.length > 0
    )
    .include('questions_v3')
    .include('subject_v2')
    .include('guide_levels_v2.guide_v1')
    .include('questions_v3.standards_v1.standard_set_v1')
    .include('questions_v3.question_set_v1.tags_v1')
    .include('questions_v3.question_set_v1.subject_v2')
    .withMeta('question_set_v1,question_v3')
    .customQuery(metaContext, Object.keys(metaContext).length !== 0)
    .pageSize(numQuestions);
  query = applySort(query, 'meta.guide_level_position');
  return query;
}
